<template lang="pug">
  v-dialog(v-model='dialog' max-width='886px' scrollable @click:outside='closeDialog')
    v-card(style='max-width: 100%;')
      v-toolbar.toolbar-settings.text-settings(style='z-index: 99999')
        span(style='font-size: 1.125rem; line-height: 1.4em; font-weight: 300; font-size: 18px;')
          | {{method === "create" ?  $t('templateEditDialog.notificationTitle') : `ID: ${itemId}`}}
        v-spacer
        v-btn#closeIcon(icon color='white' @click='closeDialog')
          md-icon close
      v-card-text(style="max-height: 686px; color: unset;" class='px-0 py-0')
        v-form.pa-0(ref="registerTemplate")
          v-skeleton-loader(
            v-if="loadingTemplate && isViewOredit"
            type="list-item-avatar-two-line, list-item-avatar-two-line,list-item-avatar-three-line, list-item-avatar-two-line, list-item-avatar-three-line, list-item-avatar-two-line"
            max-width="300"
            heigth="auto"
          )
          v-stepper(v-else v-model='stepper' vertical class="stepper" :class="{'single-step': stepper === 1}" )
            v-stepper-step(
              :complete='stepper > 1'
              :step='1'
              :editable='!isViewOredit && stepper > 1 '
              edit-icon="$complete"
              :color="isViewOredit ? '#9E9E9E' : '#72B168'"
            )
              | {{$t('templateEditDialog.channel')}}
              small(v-if='channelSelected && stepper > 1').mt-2 {{ selectedChannel }}
            v-stepper-content(:step="1")
              v-select(v-model='channelSelected' :items='filteredChannels' item-text='name' item-value='id'
                :rules='rules.required' :label="$t('templateEditDialog.selectChannel')" )
              v-btn(:disabled='!channelSelected' @click='stepper = stepper + 1 ' color="#72B168" style='color: white;') {{$t('templateEditDialog.continue')}}
            WhatsappSteps(
              v-if='channelSelected === "WHATSAPP" && template'
              :template='template'
              :edit='method === "edit"'
              :currentStep='stepper'
              :stepperCompleted='stepperCompleted'
              :method='method'
              :isViewOredit='isViewOredit'
              :loadingCreate='loadingCreateButton'
              :loadingApproval='loadingApproveButton'
              @prevStep='prevStep'
              @nextStep='nextStep'
              @completeStep='completeStep'
              @createTemplate='createTemplate'
              @submitForApproval='submitForApproval'
              @close="$emit('update:dialog', false)"
            )
            SmsSteps(
              v-if='channelSelected === "SMS"'
              :template='template'
              :edit='method === "edit"'
              :currentStep='stepper'
              :isViewOredit='isViewOredit'
              :stepperCompleted='stepperCompleted'
              :method='method'
              :loading='loadingCreateButton'
              @prevStep='prevStep'
              @nextStep='nextStep'
              @completeStep='completeStep'
              @close="$emit('update:dialog', false)"
              @createTemplate='createTemplate'
            )
            TeamsSteps(
              v-if='channelSelected === "TEAMS"'
              :template='template'
              :edit='method === "edit"'
              :isViewOredit='isViewOredit'
              :currentStep='stepper'
              :stepperCompleted='stepperCompleted'
              :method='method'
              :loading='loadingCreateButton'
              @prevStep='prevStep'
              @nextStep='nextStep'
              @completeStep='completeStep'
              @close="$emit('update:dialog', false)"
              @createTemplate='createTemplate'
            )
        div(v-if="method === 'view' && history.length > 0")
          v-card-title(class="mb-0 pb-0") {{ $t('commonWords.history') }}
          v-row( class="ma-0 pa-0" v-for="(item, index) in historyFormated" :key="index")
            v-card-text(style="color: #ABB7C2;") {{  item.event }} {{ item.name }} {{ $t('commonWords.in') }} {{ item.time }}
</template>

<script>
import * as moment from 'moment'
import TextEditor from '@/components/TextEditor.vue'
import VPhone from '@/components/VPhone.vue'
import WhatsappSteps from '@/components/TemplateSteps/WhatsappSteps.vue'
import SmsSteps from '@/components/TemplateSteps/SmsSteps.vue'
import TeamsSteps from '@/components/TemplateSteps/TeamsSteps.vue'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import Swal from 'sweetalert2'

export default {
  name: 'TemplateEditDialog',
  props: {
    dialog: {
      type: Boolean
    },
    itemId: {
      type: String,
      default: null
    },
    method: {
      type: String
    }
  },
  mixins: [isTenantMixin],
  data () {
    return {
      channelSelected: null,
      stepper: 1,
      stepperKey: 0,
      stepperCompleted: false,
      availableChannels: [
        { id: 'SMS', name: 'SMS' },
        { id: 'TEAMS', name: 'Teams' },
        { id: 'WHATSAPP', name: this.$t('templates.whatsAppRequireApproval') }
      ],
      availableCategories: [
        { id: 'UTILITY', name: this.$t('templates.category.utility') },
        { id: 'MARKETING', name: this.$t('templates.category.marketing') }
      ],
      availableLanguage: [
        { id: 'es', name: this.$t('templates.language.spanish') },
        { id: 'en', name: this.$t('templates.language.english') },
        { id: 'pt_br', name: this.$t('templates.language.portuguese') }
      ],
      buttonGroup: null,
      template: {
        name: '',
        category: '',
        language: '',
        status: '',
        text: '',
        buttons: []
      },
      history: [],
      channel: null,
      rules: {
        required: [v => !!v || this.$t('commonPhrases.requiredField')],
        atLeastOne: [v => !!v || this.$t('templateEditDialog.atLeastOne')],
        minLength: (value, length) => (value && value.length >= length) || this.$t('templateEditDialog.minLength'),
        uniqueName: [v => this.validateIfNameIsUnique(v)]
      },
      loadingCreateButton: false,
      loadingApproveButton: false,
      loadingTemplate: true,
      tenant: ''
    }
  },
  components: { TextEditor, VPhone, WhatsappSteps, TeamsSteps, SmsSteps },
  async created () {
    if (this.method === 'edit' || this.method === 'view') {
      this.stepper = 7
      this.stepperCompleted = true
      try {
        const response = await this.$axios.get(`${process.env.VUE_APP_BACKEND_BASE_URL}/message-templates/${this.itemId}`)
        this.transformStepsToRequest(response.data)
      } catch (error) {} finally {
        this.loadingTemplate = false
      }
    }
  },
  computed: {
    filteredChannels () {
      return this.isRegularize
        ? [{ id: 'SMS', name: 'SMS' }]
        : this.availableChannels
    },
    isViewOredit () {
      return this.method === 'view' || this.method === 'edit'
    },
    selectedChannel () {
      return this.availableChannels.find(channel => channel.id === this.channelSelected)?.name ?? ''
    },
    historyFormated () {
      return this.history.map(item => {
        return (
          {
            event: this.$t(`templateEditDialog.history.${item.event}`),
            name: ['approval', 'approved', 'rejected', 'pending'].includes(item.event) ? 'Meta' : item.user.name,
            time: moment(item.time).format('DD/MM/YYYY HH:mm:ss')
          }
        )
      })
    }
  },
  beforeDestroy () {
    this.clearState()
  },
  methods: {
    prevStep () {
      this.stepper = this.stepper - 1
    },
    nextStep () {
      this.stepper = this.stepper + 1
    },
    completeStep () {
      this.nextStep()
      this.stepperCompleted = true
    },
    transformStepsToRequest (data) {
      const { _source } = data
      const channel = _source.channels.find(channel => channel.isActive)
      this.history = _source.history ?? []
      this.channelSelected = channel.name.toUpperCase()
      this.template = {
        name: _source.name,
        category: channel.category,
        language: channel.language,
        status: channel.status,
        text: _source.messageOptions.text[0],
        buttons: _source.messageOptions.options.quick_replies
      }
      this.stepperKey++
    },
    closeDialog () {
      this.clearState()
      this.$emit('update:dialog', false)
    },
    clearState () {
      this.stepper = 1
      this.stepperCompleted = false
      this.channelSelected = null
    },
    async createTemplate (template) {
      try {
        this.loadingCreateButton = true
        const isRefsValid = this.$refs.registerTemplate.validate()
        if (!isRefsValid) {
          throw new Error(this.$t('commonPhrases.fillAllFields'))
        }
        if (isRefsValid && template) {
          const text = template.text
          const name = template.name
          const status = this.channelSelected === 'WHATSAPP' ? 'DRAFT' : 'APPROVED'
          const category = template.category ?? (this.channelSelected === 'WHATSAPP' ? 'UTILITY' : '')
          const language = template.language ?? (this.channelSelected === 'WHATSAPP' ? 'pt_br' : '')
          const buttons = template.actionButtons
          const formatedTemplate = {
            name,
            'channels': [
              {
                'name': this.channelSelected?.toLowerCase(),
                'isActive': true,
                'status': status,
                language,
                category
              }
            ],
            'messageOptions': {
              'text': [
                text
              ],
              'options': {
                'quick_replies': buttons
              }
            },
            'type': 'NOTIFICATION',
            'subtype': 'DEFAULT'
          }
          if (this.method === 'edit') {
            const response = await this.$axios.put(`${process.env.VUE_APP_BACKEND_BASE_URL}/message-templates/${this.itemId}`, formatedTemplate)
            this.template.id = response?.data?._id
            this.$emit('rerender')
            this.closeDialog()
            return response
          } else {
            const response = await this.$axios.post(`${process.env.VUE_APP_BACKEND_BASE_URL}/message-templates`, formatedTemplate)
            this.template.id = response?.data?._id
            this.$emit('rerender')
            this.closeDialog()
            return response
          }
        }
      } catch (e) {
        let messageError = e.message
        if (e.request && e.request.status === 409) {
          messageError = this.$t('campaign.duplicatedName')
        }
        Swal.fire({
          icon: 'error',
          title: this.$t('commonPhrases.invalidForm'),
          text: messageError
        })
      } finally {
        this.loadingCreateButton = false
      }
    },
    async submitForApproval (template) {
      const name = template.name
      const category = template.category
      const categoryData = {
        name,
        category: category.toUpperCase()
      }
      try {
        this.loadingApproveButton = true
        const response = await this.$axios.post(`${process.env.VUE_APP_BACKEND_BASE_URL}/message-templates/${this.itemId}/approval`, categoryData)
        if (response.data.message === 'Successful') {
          this.closeDialog()
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: this.$t('templateEditDialog.sendToApprovalError'),
          text: error
        })
      } finally {
        this.loadingApproveButton = false
      }
    },
    keyFactory (component, index) {
      return `${component}-${index}`
    }
  },
  watch: {
    itemId: async function (val) {
      try {
        if (this.method === 'edit') {
          await this.$axios.get(`${process.env.VUE_APP_BACKEND_BASE_URL}/message-templates/${this.itemId}`)
            .then(response => {
              this.transformStepsToRequest(response.data)
            })
        }
      } catch (e) {
        // console.log('error =>', e)
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.v-dialog__content {
  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 3.5px;
    background-color: #fff;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 3.5px;
    border: 2px solid #fff;
    background-color: rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
  }
}

.stepper {
  ::v-deep .v-stepper__label   {
    font-size: 14px !important;
    font-weight: 500 !important;
    color: #0D0B26 !important;

    & small {
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 20px !important;
      color: #ABB7C2 !important;
    }
  }

  ::v-deep .v-stepper__step__step > i {
    font-size: 13px;
  }

  :last-child ::v-deep .v-stepper__content:nth-last-child(2) {
    border-left: none !important;
  }
}
.single-step {
  > .v-stepper__content {
    border-left: 1px solid rgba(0, 0, 0, 0.12);
  }
}

.radio-styles {
  padding-right: 30px;
  display: flex;
  align-items: center;
}

.action-style {
  margin-left: 38px;
  display: flex;
  justify-content: space-between;

  ::v-deep > span {
    word-wrap: break-word;
  }
}

.action-else-style {
  display: flex;
  flex-direction: row-reverse;
  margin-right: 20px;
}

::v-deep .v-skeleton-loader__avatar {
  width: 32px !important;
  height: 32px !important;
}

</style>
